// Compact relative-time label, modeled after the v2 inbox
// design: "now", "12m", "1h", "2h", "1d", "Mar 14".
//
// We avoid Intl.RelativeTimeFormat because the design calls for
// short tokens (no "minute ago"/"in 2 hours" prose) and we want
// to stay locale-agnostic for the v2 React layer (English only
// for now).
export function relativeTimeLabel(
  iso: string | null | undefined,
  now: Date = new Date(),
): string {
  if (!iso) return ""

  const then = new Date(iso)
  if (Number.isNaN(then.getTime())) return ""

  const diffMs = now.getTime() - then.getTime()
  const diffMinutes = Math.round(diffMs / 60_000)

  if (diffMinutes < 1) return "now"
  if (diffMinutes < 60) return `${diffMinutes}m`

  const diffHours = Math.floor(diffMinutes / 60)
  if (diffHours < 24) return `${diffHours}h`

  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 7) return `${diffDays}d`

  // Older than a week — fall back to "Mar 14"
  return then.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  })
}
